import Image from 'next/image'
import { useRouter } from 'next/router'
import GeoAutocomplete from '#/components/GeoAutocomplete/advanced'
import IntroVideo from '#/components/IntroVideo'
import { MAP_PAGE } from '#/consts/url'
import { useGotoPlace } from '#/hooks/useGotoPlace'
import cn from '#/utils/classnames'
import imgMap from '@public/images/landing/tophap-map.jpg'
import styles from '../styles.module.scss'

export default function LandingHero() {
  const router = useRouter()
  const handleChangePlace = useGotoPlace()

  function onSearch() {
    router.push(MAP_PAGE)
  }

  return (
    <section className={cn(styles['th-section'], styles['th-hero-section'])}>
      <div className={styles['th-section-content']}>
        <Image
          alt='TopHap Real Estate'
          // srcSet={`${imgBaseUrl}/tophap-map-750.jpg 750w, ${imgBaseUrl}/tophap-map-1080.jpg 1080w, ${imgBaseUrl}/tophap-map-1440.jpg 1440w, ${imgBaseUrl}/tophap-map-1920.jpg 1920w, ${imgBaseUrl}/tophap-map.jpg 2792w`}
          className={styles['th-section-background']}
          fill
          priority
          src={imgMap}
        />
        <div className={cn(styles['th-section-texts'], 'z-10')}>
          <h1 className={styles['th-title']}>
            A New Way to {' '}
            <br />
            <strong>Research</strong>{' '}
            <br />
            Real Estate
          </h1>
          <GeoAutocomplete
            className='h-12 border-none'
            multiple={false}
            placeholder='Address, Neighborhood, City or ZIP'
            onChange={handleChangePlace}
            onSearch={onSearch}
          />
        </div>
      </div>

      <div className={styles['th-intro-video-container']}>
        <IntroVideo className={styles['th-intro-video-wrapper']} />
      </div>
    </section>
  )
}
